var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.81608 7.08333L12.9167 11.1841L11.1837 12.9167L7.08311 8.81637L2.98297 12.9167L1.25 11.1841L5.35014 7.08333L1.25 2.98259L2.98297 1.25L7.08311 5.35029L11.1837 1.25L12.9167 2.98259L8.81608 7.08333Z",
  fill: "#001246"
})));
export default SvgIconClose;